import type { InjectionKey, Ref } from 'vue'
import { inject, provide, ref } from 'vue'

/**
 * Read-only flag shared by a formalization step with its nested inputs
 * (e.g. `FileStorageInput`), avoiding prop drilling through every form.
 */
export const FORMALIZATION_READ_ONLY_KEY: InjectionKey<Ref<boolean>> = Symbol('formalizationReadOnly')

/** Provides the read-only flag to every descendant of the calling component. */
export function provideFormalizationReadOnly(isReadOnly: Ref<boolean>) {
  provide(FORMALIZATION_READ_ONLY_KEY, isReadOnly)
}

/**
 * Injects the read-only flag. Defaults to `false` when no ancestor provides it,
 * so behavior outside the terminal read-only mode stays unchanged.
 */
export function useFormalizationReadOnly(): Ref<boolean> {
  return inject(FORMALIZATION_READ_ONLY_KEY, ref(false))
}
